import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { get, size } from 'global/lib/lodash';
import useStyles from './styles';
import { setView } from 'redux/actions/view';
import { Row } from '../row';
import { Text } from '../text';
import Switch from '../switch';
import { useEdit } from '../../hooks/useEdit';
import { useFilter } from '../../hooks/useFilter';
import { useShowChanges } from '../../hooks/useShowChanges';
import { userHasPermissions } from 'redux/actions/userLogin';
import { useUser } from '../../hooks/useUser';

export const SelectLangEditBar = (props) => {
  const showTranslations = get(props, 'showTranslations', false);
  const hasPerm = userHasPermissions(['createLibrary']);
  const canEdit = get(props, 'canEdit', hasPerm);
  const canShowChanges = get(props, 'canShowChanges');
  const uhook = useUser();
  const [showLocation, setShowLocation] = useState(get(props, 'showLocation', true));

  const { editOn, toggleEdit } = useEdit();
  const { showChangesOn, toggleShowChanges } = useShowChanges();
  const { filter, changeFilter } = useFilter('library.editions')

  const lang = useSelector((state) => get(state, 'view.lang'));
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleChange = (e, val) => {
    if (val) {
      dispatch(setView({ lang: { ...lang, id: val } }));
    }
  };

  const locationOn = !!get(filter, 'useLocation', false);

  const changeLocation = () => {
    changeFilter('useLocation', !locationOn)
  }

  const userIsBuilderTier = get(uhook.libRealm, 'tier') === 'builder';
  const editionBelongsToMySelectedBuilder = get(uhook, 'selectedRealmBuilder.id') == get(props, 'edition.ownerRealmId');

  useEffect(() => {
    const tier = get(uhook.libRealm, 'tier');
    if (!editionBelongsToMySelectedBuilder) { return changeFilter('useLocation', false) }
    if (tier) {
      if (tier === 'builder') {
        changeFilter('useLocation', false) 
      } else if (tier === 'division') {
        changeFilter('useLocation', true);
      }
    }
  }, [uhook.libRealm, editionBelongsToMySelectedBuilder]);

  useEffect(() => {
    if (props.edition) {
      const edtier = get(props, 'edition.realm.tier');
      const hasdocs = get(props, 'edition.config.docs');
      if (edtier === 'division' || !hasdocs) {
        setShowLocation(false);
      }
    }
  }, [props.edition]);

  const show = showTranslations || canEdit || showLocation;

  if (!show) {
    return null;
  }

  return (
    <div className={classes.container}>
      {showTranslations && (
        <Row className={classes.rowItem}>
          <Text type={'label_medium'}>Available In</Text>
          <ToggleButtonGroup exclusive className={classes.btnGroup} size="small" value={get(lang, 'id')} onChange={handleChange}>
            {get(lang, 'avail', []).map((a) => (
              <ToggleButton key={a.id} value={a.id}>
                {a.title}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Row>
      )}

      {canEdit && (
        <Row className={classes.rowItem}>
          <Text type={'label_medium'}>Edit Tools</Text>
          <Switch checked={editOn} onChange={toggleEdit} />
        </Row>
      )}

      {canShowChanges && (
        <Row className={classes.rowItem}>
          <Text type={'label_medium'}>Show Changes</Text>
          <Switch checked={showChangesOn} onChange={() => toggleShowChanges()} />
        </Row>
      )}

      {showLocation && (
        <Row className={classes.rowItem}>
          <Text type={'label_medium'}>Use Location</Text>
          <Switch disabled={userIsBuilderTier || !editionBelongsToMySelectedBuilder} checked={locationOn} onChange={changeLocation} />
        </Row>
      )}
    </div>
  );
};
